import "./member.css";
import React, { useEffect, useState } from "react";
import { ApiService } from "../../services/http.service";
import { env } from "../../constants/global.vars";
import { modalServiceSubject } from "../../services/modal.service";

const platformMapping = {
  0: 'Web',
  1: 'Mobil',
  2: 'Bilinmeyen'
}

export function MemberSession() {
  const [sessions, setSessions] = useState([]);

  const getSessions = async () => {
    const api = new ApiService();
    try {
      const response: any = await api.start("get", env.accounting_api + "/member/api/handle-member-session/", {}, true)
      console.log(response);
      setSessions(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const closeSession = async (id: string) => {
    const api = new ApiService();
    try {
      modalServiceSubject.next({
        title: "Emin misiniz?",
        content: `Bu oturumunuzu kapatmak istediğinize emin misiniz?`,
        confirm: {
          sure: {
            class: "btn-danger fs-7 fw-semibold",
            label: "Evet",
            action: () => {
              api.start("post", env.accounting_api + "/member/api/handle-member-session/", { id: id.toString() }, true).then((res: any) => {
                if (res.status) {
                  getSessions();
                } else {
                  modalServiceSubject.next({
                    title: "Hata",
                    content: res.message,
                    timeout: 3000,
                  });
                }
              });
            },
          },
          cancel: {
            class: "btn-secondary fs-7 fw-semibold",
            label: "Vazgeç",
          },
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const closeAllSessions = () => {
    const api = new ApiService();
    try {
      const activeSessionIds = sessions
        .filter((session: any) => !isSessionExpired(session.expiry_date))
        .map((session: any) => session.id)
        .join(',');
      if (activeSessionIds) {
        modalServiceSubject.next({
          title: "Emin misiniz?",
          content: `Tüm oturumlarınızı kapatmak istediğinize emin misiniz?`,
          confirm: {
            sure: {
              class: "btn-danger fs-7 fw-semibold",
              label: "Evet",
              action: () => {
                api.start("post", env.accounting_api + "/member/api/handle-member-session/", { id: activeSessionIds }, true).then((res: any) => {
                  if (res.status) {
                    getSessions();
                  } else {
                    modalServiceSubject.next({
                      title: "Hata",
                      content: res.message,
                      timeout: 3000,
                    });
                  }
                });
              },
            },
            cancel: {
              class: "btn-secondary fs-7 fw-semibold",
              label: "Vazgeç",
            },
          },
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const isSessionExpired = (expiry_date: string) => {
    return new Date(expiry_date) < new Date();
  };

  useEffect(() => {
    getSessions();
  }, []);

  return (
    <>
      <h1>Oturumlarım</h1>
      <div className="page-widget">
        <div className={"p-2"}>
          <div className={"table-responsive"}>
            <table className="table table-borderless betting-table">
              <thead>
                <tr>
                  <th>Platform</th>
                  <th>Detay</th>
                  <th>Son Giriş</th>
                  <th style={{ width: 110 }} className="text-center">İşlem</th>
                </tr>
              </thead>
              <tbody>
                {sessions.length > 0 ? (
                  sessions.map((session: any, index: number) => (
                    <React.Fragment key={`session-${index}`}>
                      <tr>
                        <th className="seperator"></th>
                      </tr>
                      <tr>
                        <td className="fw-semibold">{session.platform}</td>
                        <td className="fw-semibold tooltip" style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{session.platform_detail}
                          <span className="tooltip-text">{session.platform_detail}</span>
                        </td>
                        <td>{new Date(session.create_date).toLocaleString()}</td>
                        <td className="text-center">
                          <button
                            className="btn btn-danger btn-sm fw-semibold fs-7"
                            onClick={() => closeSession(session.id)}
                            disabled={isSessionExpired(session.expiry_date)}
                          >
                            Oturumu Kapat
                          </button>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} className="text-center">
                      <p className="fs-7">Henüz oturum bilgisi bulunmamaktadır.</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {sessions.length > 0 && (
              <div className="text-center mt-3">
                <button
                  className="btn btn-sm btn-danger fw-semibold fs-7"
                  onClick={closeAllSessions}
                >
                  Tüm Oturumları Kapat
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
